export default __webpack_public_path__ + "static/media/sec-10.b4886afe.jpg";